import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import Modal from "./components/Modal";

export default function App(){
  const [openSignup, setOpenSignup] = useState(false);

  // theme init (persist)
  useEffect(() => {
    const saved = localStorage.getItem("theme");
    if (saved === "dark") document.documentElement.classList.add("dark");
    else if (saved === "light") document.documentElement.classList.remove("dark");
    else {
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      if (prefersDark) document.documentElement.classList.add("dark");
    }
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-[#071026] text-gray-900 dark:text-gray-100 transition-colors duration-300">
      {/* scroll progress bar */}
      <div id="scroll-progress" style={{ width: "0%" }} />

      <Navbar onOpenSignup={() => setOpenSignup(true)} />
      <main className="max-w-6xl mx-auto px-6 pt-20"> {/* pt-20 to account for fixed navbar */}
        <Hero onCTAClick={() => setOpenSignup(true)} />
        <Features />
        <HowItWorks />
        <Testimonials />
        <section className="py-12">
          <div className="rounded-2xl p-8 section-grad-light dark:section-grad-light border dark:border-gray-700">
            <h3 className="text-2xl font-bold">Ready to try FinBit?</h3>
            <p className="mt-2 text-gray-600 dark:text-gray-300">Join our beta — get early access, rewards and campus ambassador opportunities.</p>
            <div className="mt-4">
              <button onClick={() => setOpenSignup(true)} className="inline-flex items-center gap-3 px-5 py-3 rounded-full text-white font-semibold bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] shadow-lg hover:scale-[1.02] transform transition">
                Get Early Access
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Floating CTA */}
      <button
        onClick={() => setOpenSignup(true)}
        aria-label="Sign up for beta"
        className="fixed right-5 bottom-6 z-50 inline-flex items-center gap-3 px-4 py-3 rounded-full text-white bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] shadow-2xl hover:scale-105 transition-transform"
      >
        ✨ Join Beta
      </button>

      <Modal open={openSignup} onClose={() => setOpenSignup(false)} />
    </div>
  );
}
